// extracted by mini-css-extract-plugin
export default {"container":"team-member_container__2kgez","button":"team-member_button__3FvmX"};